import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { SET_CURRENT_USER, UNSET_CURRENT_USER } from './LoginTypes';

export const useLogin = () => {
  const dispatch = useDispatch();

  const userInfo = useSelector(state => state.auth.user);
  const setCurrentUser = useCallback(
    user =>
      dispatch({
        type: SET_CURRENT_USER,
        payload: user
      }),
    [dispatch]
  );
  const unsetCurrentUser = useCallback(
    () =>
      dispatch({
        type: UNSET_CURRENT_USER
      }),
    [dispatch]
  );

  return { userInfo, setCurrentUser, unsetCurrentUser };
};
